import React, { useState, useEffect, useRef } from 'react';
import { INDEX_URL, CUST, icons, markers, FLAVOR } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { downloadPDF, fixDate, getMapMarker, staticSort } from '../../helpers/helperFunctions';
import Button from '../Buttons/Button';
import Searchbar from '../Searchbar/Searchbar';
import AddDevice from "../../components/Modals/AddDevice";
import ShareDevice from "../../components/Modals/ShareDevice";
import { useContextData } from '../../components/ContextData';
import DeviceModal from '../Modals/DeviceModal';
import { Collapse } from '@mui/material';
import { useIsMobile } from '../../helpers/customHooks';
import toast from 'react-hot-toast';
import AlarmCentralModal from '../Modals/AlarmCentralModal';
import ExportDataModal from '../Modals/ExportDataModal';
import StolenModeModal from '../Modals/StolenModeModal';
import SearchbarNew from '../Searchbar/SearchbarNew';
import { useSidebarContext } from '../Sidebar/SiderbarContext';
import { AnimatePresence, motion } from "framer-motion";
import AlcolockModal from '../Modals/AlcolockModal';
import AddDeviceModal from '../Modals/AddDeviceModal';
import SharingModal from '../Modals/SharingModal';

const Devices = ( {isOpen, setIsOpen, outerType, setSelectedDevice, setOuterType} ) => {
    const MOBILE = useIsMobile();
	const { t } = useTranslation();
    const [myDevicesFull, setMyDevicesFull] = useState([])
    const [myDevices, setMyDevices] = useState([])
    const [sharedDevicesFull, setSharedDevicesFull] = useState([])
    const [sharedDevices, setSharedDevices] = useState([])
    const [pendingInvites, setPendingInvites] = useState([])
    const [addDevice, setAddDevice] = useState(false)
    const [shareDevice, setShareDevice] = useState(false)
    const [allDevices, setAllDevices] = useState([])
    const [openDevice, setOpenDevice] = useState()
    const [currentIcon, setCurrentIcon] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(true)
    const [type, setType] = useState()
    const [centrals, setCentrals] = useState([])
    const [alarmCentralShow, setAlarmCentralShow] = useState(false)
    const [showAlarmModal, setShowAlarmModal] = useState(false)
    const [alarmType, setAlarmType] = useState()
    const [devicesSharing, setDevicesSharing] = useState([])
    const [testInfo, setTestInfo] = useState()

    // const [showSpecificDevice, setShowSpecificDevice] = useState(false)
    const [exportDataShow, setExportDataShow] = useState(false)
    const [stolenModeShow, setStolenModeShow] = useState(false)
    const [showExportModal, setShowExportModal] = useState(false)
    const [showStolenModeModal, setShowStolenModeModal] = useState(false)
    const [exportInfo, setExportInfo] = useState()
    const [exportType, setExportType] = useState({})

    const [exportedList, setExportedList] = useState([])

    const [stolenModeInfo, setStolenModeInfo] = useState()
    const [stolenModeType, setStolenModeType] = useState("activate")
    const [showAlcoModal, setShowAlcoModal] = useState(false)
    const [documentsShow, setDocumentsShow] = useState(false)
    const [sharingShow, setSharingShow] = useState(false)
    const [showSharingModal, setShowSharingModal] = useState(false)
    const [sharingAccount, setSharingAccount] = useState(null)
    const [sharingAlarmShow, setSharingAlarmShow] = useState(false);
    const [sharingDevices, setSharingDevices] = useState([]);

    const [modals, setModals] = useState({
        add_device: false,
        share_device: false
    });
    
    const toggleModal = (modalName) => {
        setType(modalName)
        setModals((prevState) => ({
            ...prevState,
            [modalName]: !prevState[modalName],
        }));
    };

    useEffect(() => {
        getDevices()
        getSharingInfo()
        // if(process.env.REACT_APP_FLAVOR === "tracking"){
        //     getCentralInfo()
        // }
    }, [])

    const handleClose = () => {
        setShowModal(false)
        setShowAlcoModal(false)
        setShowSharingModal(false)
        setType(null)
        setSharingAccount(null)
    }

    const getSharingInfo = () => {
        const obj = {
            type: "check_permission_device_shared_limit"
        }
        request.post("", "devices/info/extended", obj).then((response) => {
            let sorted = staticSort(response?.data.devices, "name")
            setDevicesSharing(sorted)
        })
    }
    
    // const getCentralInfo = () => {
    //     request.get("alarmcenter/central/info")
    //         .then((response) => {
    //             setCentrals(response.data.response)
    //         })
    //         .catch((error) => {
    //             console.error(error)
    //         })   
    // }


    const getDevices = () => {
        request.get("devices/list").then((response) => {
            const devices = response.data.devices
            const pending = response.data.pendingSharedDevices
            const shared = devices?.filter((device) => device.sharedstatus.withme)
            const mine = devices?.filter((device) => !device.sharedstatus.withme)
            let sortedShared = staticSort(shared, "name")
            let sortedMine = staticSort(mine, "name")            
            setAllDevices(devices)
            setMyDevices(sortedMine ?? [])
            setMyDevicesFull(sortedMine ?? [])
            setSharedDevices(sortedShared ?? [])
            setSharedDevicesFull(sortedShared ?? [])
            setPendingInvites(pending  ?? [])
            setLoading(false)
        }) 
    }

    const getTestInfo = (confirm = false) => {
        request.post("", "alarmcenter/device/installationtest", {deviceid: openDevice.id, confirm: confirm}).then((response) => {  
            if(confirm){
                setShowAlarmModal(false)
                getDevices()
                clickDevice(openDevice?.id)
            }else{
                setTestInfo(response.data.response)
            }
        })
    }

    const filterSearch = (searchWord) => {
			if(!searchWord || searchWord === ""){
                setMyDevices(myDevicesFull)
                setSharedDevices(sharedDevicesFull)
				return
			}
            let arrayMy = myDevicesFull;
			let matchMy = arrayMy?.filter((device) => {
			const item = searchWord.toLowerCase();
			return (
				device.name.toLowerCase().indexOf(item) > -1 ||
				device.uniqueid.toLowerCase().indexOf(item) > -1 ||
                device?.vehicleinfo?.vinnumber?.toLowerCase().indexOf(item) > -1
			  );
			})
            let arrayShared = sharedDevicesFull
            let matchShared = arrayShared?.filter((device) => {
            const item = searchWord.toLowerCase();
            return (
                device.name.toLowerCase().indexOf(item) > -1 ||
                device.uniqueid.toLowerCase().indexOf(item) > -1 ||
                device?.vehicleinfo?.vinnumber?.toLowerCase().indexOf(item) > -1
                );
            })
			setMyDevices(matchMy)
			setSharedDevices(matchShared)
	}

    useEffect(() => {
        if(openDevice){
            setCurrentIcon(
                {
                    icon: openDevice?.mapicon?.split("_")[0] ?? "default",
                    color: openDevice?.mapicon?.split("_")[1] ?? "blue"
                }
            )
            setSelectedDevice(openDevice?.name)
            filterSearch("")
        }else{
            filterSearch("")
            setSelectedDevice(null)
        }
    }, [openDevice])

    const openModal = (type) => {
        if(type === "imei" || type === "battery"){
            return
        }
        setType(type)
        if(type === "engineblock" || type === "override"){
            setShowAlcoModal(!showAlcoModal)
        }else{
            setShowModal(!showModal)
        }
    }

    const openAlarmModal = (type) => {  
        const centralid = alarmcenter?.centerid
        if(type === "central" && centralid !== null){
            toast.error(t("toast.unlink_central_first"))
            return
        }
        setShowAlarmModal(!showAlarmModal)
        setAlarmType(type)
        if(type === "installation_test"){
            getTestInfo()
        }
    }

    // useEffect(() => {
    //     if(!isOpen){
    //         setOpenDevice(false)
    //     }
    // }, [isOpen])


    const updateAlcoInfo = (content) => {
		content.deviceid = [openDevice?.id]
		request.post("", "devices/external/command", content).then((response) => {
			if (response.data.successful) {
				toast.success(t("toast.success"));
				handleClose()
                clickDevice(openDevice?.id)
			} else {
				const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
			}
		});		
	}

    const saveData = (data, reset = false) => {
        let url;
        if(type === "override" || type === "engineblock"){
            url = "devices/external/command"
        }else{
            url = "device/update"
        }

        request.post("", url, data).then((response) => {
            if(type === "override" || type === "engineblock"){
                if(response?.data?.deniedDevices?.length > 0){
                    toast.error(response?.data?.deniedDevices[0].reason)
                }else{
                    toast.success(t("toast.success"))
                    if(!reset){
                        setShowModal(!showModal)
                    }
                    clickDevice(openDevice?.id)
                    getDevices()
                }
                return
            }
            if(response.data?.successful){
                if(!reset){
                    toast.success(t("toast.success"))
                    setShowModal(!showModal)
                }
                clickDevice(openDevice?.id)
                getDevices()
                console.log("YR?SES:")

            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }


    const saveDataAlarm = (data, reset = false) => {
        request.post("", "device/update", data).then((response) => {
            if(response.data?.successful){
                if(!reset){
                    toast.success(t("toast.success"))
                    setShowAlarmModal(!showAlarmModal)
                }
                clickDevice(openDevice?.id)
            }else{
                const msg = response?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }

    const saveDataExport = (data, reset = false) => {
        request.post("", "history/export/generate", data).then((response) => {
            if(response?.data?.successful){
                const msg = response?.data?.message
                toast.success(msg)
                setShowExportModal(false)
                setTimeout(() => {
                    getExportList()
                }, 1000);
            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }


    const saveDataStolenMode = async (data, reset = false) => {
        try {
            // If data.img is a File object, upload it first
            if (data.img instanceof File) {
                const formData = {
                    type: "stolenmode",
                    image: data.img,
                    entity_id: openDevice?.id
                }
                const uploadedImgResponse = await request.putNew("media/upload", formData);

                if (uploadedImgResponse?.data?.successful) {
                    // toast.success(t("toast.saved"));
                } else {
                    toast.error(t("toast.image_upload_failed"));
                    return;
                }
            }

            delete data.img
            const response = await request.post("", "devices/stolenmode", data);

            if (response?.data?.successful) {
                if (data?.action === "configure") {
                    toast.success(t("toast.saved"));
                } else {
                    if (response?.data?.response?.active) {
                        toast.success(t("toast.stolen_mode_activated"));
                    } else {
                        toast.success(t("toast.stolen_mode_deactivated"));
                    }
                }
                setShowStolenModeModal(false);
                getStolenModeInfo();
            } else {
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        } catch (error) {
            console.error("Stolen mode save failed:", error);
            toast.error(error ?? t("toast.error"))
        }
    }


    const deleteStolenModeImg = () => {
        const data = {
            type: "stolenmode",
            entity_id: openDevice?.id
        }
        request.post("", "media/delete", data).then((response) => {
            if(response?.data?.successful){
                toast.success(t("toast.success"))
            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }

    const removeShared = (pending, id, email) => {
        if(pending){
            request.post("", "device/share/revokependinginvitation", {deviceid: [openDevice.id], email: [email]}).then((response) => {
                if(response.data){
                    toast.success(t("toast.success"))
                    clickDevice(openDevice?.id)
                    handleClose()
                    getSharingInfo()
                }
            })
        }else{
            request.post("", "device/delete", {deviceid: [openDevice.id], sharedid: [id]}).then((response) => {
                if(response.data){
                    toast.success(t("toast.success"))
                    clickDevice(openDevice?.id)
                    handleClose()
                    getSharingInfo()
                }
            })  
        }
    }

    const deleteData = (type) => {
        let url;
        let id;
        let obj;
        switch(type){
            case "delete_history":
                obj = { deviceid: openDevice.id, type: "all" }
                url = "data/device/delete"
                //id = openDevice.id
                break;
            case "delete_device":
                obj = { deviceid: [openDevice.id]}
                url = "device/delete"
                break;
            default: return
        }
        request.post("", url, obj).then((response) => {            
            if(response.data.successful){
                setShowModal(!showModal)
                getDevices()
                setOpenDevice()
                getSharingInfo()
                if(response.data.failed_devices?.length > 0){
                    let device = response.data.failed_devices[0]
                    let content = 
                    <div className="d-flex flex-column">
                        <p>{t("settings.couldnt_delete")}: {device.name}</p>
                        <p>{t("settings.reason")}: {device.reason}</p>
                    </div>
                    toast.error(content)
                }else{
                    toast.success(t("toast.done"))
                }
            }else{
                toast.error(response?.data?.message)
            }
        })
    }


    const sendTestAlarm = () => {
        return request.post("", "alarmcenter/device/sendtestalarm", {deviceid: openDevice?.id, confirm: true})
        .then((response) => {
            if(response.data.error){
                toast.error(t(response.data.message))
            }
            clickDevice(openDevice?.id)
            return response;
        })
        .catch((error) => {
            console.error("Error: ", error);
            throw error;
        });
    };

    const downloadCertificate = () => {
        return request.generatePDFpost("alarmcenter/device/installation/certification/generate", {deviceid: openDevice?.id})
        .then((response) => {
            if(response.status === 404){
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }else{
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);                
                const link = document.createElement('a');
                link.target = "_blank";
                link.href = url;
                link.download = "swetrack_certificate"; // Set the file name for the download
            
                // Append the link to the document, trigger a click, and then remove it
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            
                // Clean up the URL object
                window.URL.revokeObjectURL(url);
            }

        
        })
        .catch((error) => {
            toast.error(t("toast.error"));
            console.error("Error: ", error);
            throw error;
        });
    };

    const alarmcenter = openDevice?.alarmcenter
    const dataplan = openDevice?.dataplan
    const exportdata = openDevice?.exportdata
    const iotinfo = openDevice?.iotinfo
    const sharedstatus = openDevice?.sharedstatus
    const speedlimit = openDevice?.speedlimit
    const stolenmode = openDevice?.stolenmode
    const visibleswitch = openDevice?.visibleswitch
    const vehicleinfo = openDevice?.vehicleinfo
    const _external = openDevice?.external_hardwareinfo

    const _psm = iotinfo?.psm

    const info = [
        {
            valid: visibleswitch?.infodevice?.external_power,
            title: t("settings.battery_external"),
            data: `${iotinfo?.power?.powersupply?.info} ${iotinfo?.power?.powersupply?.unit}`
        },
        {
            valid: visibleswitch?.infodevice?.battery,
            title: t("settings.battery_internal"),
            data: `${iotinfo?.power?.battery?.info} ${iotinfo?.power?.battery?.unit}`
        },
        {
            valid: visibleswitch?.infodevice?.temperature,
            title: t("settings.temperature"),
            data:`${(iotinfo?.temp_hum?.currentdata?.temperature?.info/100).toFixed(1)}${iotinfo?.temp_hum?.currentdata?.temperature?.unit}`
        },
        {
            valid: visibleswitch?.infodevice?.humidity,
            title: t("settings.humidity"),
            data:`${(iotinfo?.temp_hum?.currentdata?.humidity?.info/100).toFixed(1)}${iotinfo?.temp_hum?.currentdata?.humidity?.unit}`
        },

    ]
    const options = [
        {
            name: "devicename",
            valid: visibleswitch?.editdevice?.name,
            title: t("settings.name"),
            data: openDevice?.name,
            icon: icons.dots_vertical,
            function: () => openModal("devicename")
        },
        {
            name: "imei",
            valid: visibleswitch?.editdevice?.uniqueid,
            title: t("settings.imei"),
            data: openDevice?.uniqueid
        },
        {
            name: "vinnumber",
            valid: visibleswitch?.editdevice?.vinnumber,
            title: t("settings.vin"),
            data: vehicleinfo?.vinnumber
        },
        {
            name: "speedlimit",
            valid: visibleswitch?.editdevice?.speedlimit,
            title: t("settings.speed_settings"),
            data: speedlimit?.info ? `${speedlimit?.info} ${speedlimit?.unit}` : t("settings.not_set"),
            icon: icons.dots_vertical,
            function: () => openModal("speedlimit")

        },
        {
            name: "map_icon",
            valid: visibleswitch?.editdevice?.mapicon,
            title: t("settings.map_icon"),
            data: openDevice && getMapMarker(openDevice?.mapicon, true),
            
            icon: icons.dots_vertical,
            img: true,
            function: () => openModal("map_icon")

        },
        {
            name: "powersaving",
            valid: visibleswitch?.editdevice?.psm,
            title: t("settings.powersaving"),
            icon: icons.dots_vertical,
            function: () => openModal("powersaving")

        },
        {
            name: "wakeup",
            valid: visibleswitch?.editdevice?.wakeupmode,
            title: t("settings.wakeup"),
            icon: icons.dots_vertical,
            function: () => openModal("wakeup")

        },
        {
            name: "temperature",
            valid: visibleswitch?.editdevice?.alarm_temp,
            title: t("settings.temperature"),
            icon: icons.dots_vertical,
            function: () => openModal("temperature")

        },
        {
            name: "humidity",
            valid: visibleswitch?.editdevice?.alarm_hum,
            title: t("settings.humidity"),
            icon: icons.dots_vertical,
            function: () => openModal("humidity")

        },
        {
            name: "alarm_central",
            valid: visibleswitch?.editdevice?.alarmcentral,
            title: t("settings.alarm_central"),
            icon: icons.chevron_right,
            function: () => setOuterType("alarm_central")

        },
        {
            name: "override",
            valid: visibleswitch?.editdevice?.override,
            title: t("settings.override"),
            icon: icons.dots_vertical,
            data: _external?.override?.pending.active ? t("settings.pending") : _external?.override?.current?.active ? _external?.override?.current?.overrideuntil : t("settings.no"),
            function: () => openModal("override")
        },
        {
            name: "engineblock",
            valid: visibleswitch?.editdevice?.engineblock,
            title: t("settings.engine_block"),
            icon: icons.dots_vertical,
            data: _external?.engineblock?.pending ? t("settings.pending") : _external?.engineblock?.status ? t("settings.yes"): t("settings.no"),
            function: () => openModal("engineblock")
        },
        {
            name: "sharing",
            valid: visibleswitch?.editdevice?.sharing,
            title: t("settings.sharing_management"),
            icon: icons.chevron_right,
            function: () => setOuterType("sharing")
        },
        {
            name: "stolen_mode",
            valid: visibleswitch?.editdevice?.stolen_mode,
            title: t("settings.stolen_mode"),
            icon: icons.chevron_right,
            function: () =>setOuterType("stolen_mode")
        },
        {
            name: "export",
            valid: visibleswitch?.editdevice?.export_data,
            title: t("settings.export_data"),
            icon: icons.chevron_right,
            function: () => setOuterType("export_data")
        },
        {
            name: "delete_history",
            valid: visibleswitch?.editdevice?.delete,
            title: t("settings.delete_data"),
            danger: true,
            icon: icons.chevron_right,
            function: () => openModal("delete_history")

        },
        {
            name: "delete_device",
            valid: visibleswitch?.editdevice?.delete,
            title: t("settings.delete_device"),
            danger: true,
            icon: icons.chevron_right,
            function: () => openModal("delete_device")
        },
    ]

    const validOptions = () => {
        return options.filter(option => option.valid)
    }

    const validInfo = () => {
        return info.filter(info => info.valid)
    }

    const handleInvite = (accept, id) => {
        request.post("", "device/share/acceptdenyinvitation", {deviceid: [id], accept: accept}).then((response) => {
            if(response.data.successful){
                getDevices()
            }else{
                alert("error")
            }
        })
    }

    const alarmCentralInfo = [
        {
            name: "central",
            valid: true,
            title: t("settings.alarm_central"),
            data: alarmcenter?.centername ?? "",
            icon: icons.dots_vertical,
            function: () => openAlarmModal("central")
        },
        {
            name: "info",
            valid: alarmcenter?.centerid !== null && alarmcenter?.allowed,
            title: t("settings.additional_info"),
            data: null,
            icon: icons.dots_vertical,
            function: () => openAlarmModal("info")
        },
        {
            name: "test",
            valid: alarmcenter?.centerid !== null && alarmcenter?.allowed,
            title: t("settings.installation_test"),
            data: fixDate(alarmcenter?.installationtest, true) ?? "",
            icon: icons.dots_vertical,
            function: () => openAlarmModal("installation_test")
        },
        {
            name: "unlink",
            valid: alarmcenter?.centerid !== null && alarmcenter?.allowed,
            title: t("settings.unlink_alarm"),
            danger: true,
            icon: icons.chevron_right,
            function: () => openAlarmModal("unlink_central")

        },
    ]

    const validAlarmCentral = () => {
        return alarmCentralInfo.filter(option => option.valid)
    }


    // const getExportInfo = () => {
    //     const obj = {
    //         type: "check_permission_device_history_export"
    //     }
    //     request.post("", "devices/info/extended", obj).then((response) => {
    //         const innerDevice = response?.data?.devices?.find(device => device.id === openDevice?.id)
    //         console.log("INNER DEVICE?: ", innerDevice)
    //         const hit = innerDevice[0]?.history_export_permissions
    //         setExportInfo(hit)
    //     })
    // }

    const getExportList = () => {
        const data = {
            deviceid: openDevice?.id
        }
        request.post("", "history/export/info", data).then((response) => {
            setExportedList(response?.data?.exports)
        })
    }

    useEffect(() => {
        if(exportDataShow){
        //    getExportInfo()
            getExportList()
        }
    }, [exportDataShow])

    const openExportModal = (type, content) => {

        // console.log("EXPORT: ", exportInfo)
        // if(!exportInfo?.export){
        //     toast.error(exportInfo?.message)
        //     return
        // }
        // setExportType({
        //     type,
        //     ...(content != null ? { content } : {})
        // });
        // setShowExportModal(!showExportModal)
        if(!openDevice?.exportdata?.allowed){
            toast.error(openDevice?.exportdata?.message)
            return
        }
        setExportType({
            type,
            ...(content != null ? { content } : {})
        });
        setShowExportModal(!showExportModal)
    }

    const downloadData = (url) => {
        const obj = { downloadtoken: url}
        request.post("", "history/export/download", obj).then((response) => {
            if(response.data.successful){
                const file = response?.data?.url
                downloadPDF(file)
            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }


    const getStolenModeInfo = () => {
        const data = {
            deviceid: openDevice?.id,
            action: "status"
        }
        request.post("", "devices/stolenmode", data).then((response) => {
            if(response.data.successful){
            const content = response?.data?.response
            setStolenModeInfo(content)

            }else{
                toast.error()
            }
        })
    }

    useEffect(() => {
        if(stolenModeShow){
        getStolenModeInfo()
        }
    }, [stolenModeShow])


    const handleOpenStolenMode = (type) => {
        if(type === "additional"){
            setStolenModeType(type)
            setShowStolenModeModal(!showStolenModeModal)
        }else if(type === "link"){
            setStolenModeType(type)
            setShowStolenModeModal(!showStolenModeModal)
        }else if(type === "activate"){
            setStolenModeType(type)
            setShowStolenModeModal(!showStolenModeModal)
        }else{
            let data = {}
            let reset = false
            data.deviceid = openDevice?.id
            data.action = "deactivate"
            saveDataStolenMode(data, reset)
        }
    }

    const clickDevice = async(realid) => {
        setIsOpen(true)
        try{
            const response = await request.post("", "device/settings/info", { deviceid: realid })
            const device = response?.data?.device
            setOpenDevice(device)
        }catch{

        }finally{
        // setShowSpecificDevice(true)

        }
    }
    
    const handleShowAddModal = (inner) => {
        setType(inner)
        if(inner === "add_device"){
            setAddDevice(!addDevice)
        }else if(inner === "share_device"){
            setShareDevice(!shareDevice)
        }else{
            setAddDevice(null)
            setShareDevice(null)
        }
    }

    const addDeviceFunc = (data) => {
        if(type === "add_device"){
            request.post("", "device/create", data).then((response) => {
                if(response.data){
                    if(response.data.error){
                        toast.error(response.data.message)
                    }else{
                        setTimeout(() => {
                            toast.success(t("toast.added"))
                            getDevices()
                            getSharingInfo()
                            toggleModal(type)
                        }, 500);  
                    }
                }
            })
            return
        }
        if(type === "share_device"){
            request.post("", "device/share/create", data).then((response) => {
                if(response.data.successful){ 
                    toast.success(t("toast.success"))
                    handleClose()
                    clickDevice(openDevice?.id)
                    getSharingInfo()
                    //HERE
                }else{
                    toast.error(response.data.message)
                }
            })
        }

    }

    const toggleSharingModal = (type, item = null) => {
        setType(type)
        setShowSharingModal(true)
        if(type === "status" || type === "alarm_item" || type === "share_multiple"){
            setSharingAccount(item)
        }
    }


    const updateSharing = (data) => {
        if(type === "share_device"){
            data.deviceid = [openDevice?.id]
            request.post("", "device/share/create", data).then((response) => {
                if(response.data.successful){ 
                    toast.success(t("toast.success"))
                    handleClose()
                    clickDevice(openDevice?.id)
                    getSharingInfo()
                }else{
                    toast.error(response.data.message)
                }
            })
            return
        }
        if(type === "status"){
            removeShared(data?.info?.pending, data?.info?.userid, data?.info?.email)
        }
        if(type === "alarm_item"){
            if(data?.removed?.length > 0){
                const obj = {
                    deviceid: data?.device,
                    email: data?.removed
                }
                request.post("", "events/share/delete", obj).then((response) => {
                    if(response.data.successful){
                        toast.success(t("toast.success"))
                        handleClose()
                        getSharingData()
                    }
                })
            }
            if(data.added?.length > 0){
                const obj = {
                    deviceid: data?.device,
                    email: data?.added
                }
                request.post("", "events/share/add", obj).then((response) => {
                    if(response.data.successful){
                        toast.success(t("toast.success"))
                        handleClose()
                        getSharingData()
                    }
                })
            }  
        }
        if(type === "share_multiple"){
            const obj = {
                deviceid: data?.devices,
                email: data?.added
            }
            request.post("", "events/share/add", obj).then((response) => {
                if(response.data.successful){
                    toast.success(t("toast.success"))
                    handleClose()
                    getSharingData()
                }
            })  
        }
        if(type === "remove_email"){
            const deviceIds = sharingDevices?.map(dev => dev.deviceid) ?? [];
            const obj = {
                deviceid: deviceIds,
                email: [data?.email]
            } 
            request.post("", "events/share/delete", obj).then((response) => {
                if(response.data.successful){
                    toast.success(t("toast.success"))
                    handleClose()
                    getSharingData()
                }
            })  
        }

    }
    
    const closeViews = () => {
        setDocumentsShow(false)
        setSharingShow(false)
        setStolenModeShow(false)
        setExportDataShow(false)
        setAlarmCentralShow(false)
        setSharingAlarmShow(false)

    }
    useEffect(() => {
        if(!isOpen){
            setOpenDevice(null)
        }
    }, [isOpen])

    useEffect(() => {
        if(!outerType){
            closeViews()
            return
        }
        switch(outerType){
            case "documents":
                setDocumentsShow(true)
            break;
            case "sharing":
                setSharingShow(true)
            break;
            case "stolen_mode":
                setStolenModeShow(true)
            break;
            case "export_data":
                setExportDataShow(true)
            break;
            case "alarm_central":
                setAlarmCentralShow(true)
            break;
            case "sharing_alarm":
                setSharingAlarmShow(true)
            default: return            
        }
    }, [outerType])


    const getSharingData = () => {
            request.get("events/share/list")
                .then((response) => {
                    setSharingDevices(response?.data)
                })
                .catch((error) => {
                    console.error(error)
                })   
    }

    useEffect(() => {
        if(sharingAlarmShow){
            getSharingData()
        }
    }, [sharingAlarmShow])



    const noDeviceSelectedView = () => (
        <>
        <div className="d-flex flex-column">
            <div className="w-50">
                <SearchbarNew submitSearch={(data) => filterSearch(data)} />
            </div>
            <p className="bold mt-3 mb-1">{t("settings.my_devices")}</p>
            <div className="d-flex flex-column">
                <div className={`settings-radius`}>
                {loading &&
                    <div className={`p-3 w-100 d-flex flex-column placeholder-glow`} >
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="regular placeholder w-50"></span>
                        </div>
                    </div>
                }
                {myDevices && myDevices.map((device, index) => (
                    <div key={index} className={`p-3 w-100 d-flex flex-column bg-white ${index < myDevices.length-1 ? "border-settings" : ""} cursor-pointer`} onClick={() => clickDevice(device.id)}>
                        <div className="d-flex justify-content-between align-items-center overflow-hidden">
                            <span className="regular  text-truncate me-3">{device.name}</span>
                            <img className="size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />
                        </div>
                    </div>
                ))}
                </div>
                {myDevices && myDevices?.length === 0 && !loading &&
                    <div className={`p-3 w-100 d-flex flex-column bg-transparent`}>
                        <span className="regular">{t("settings.no_devices")}</span>
                    </div>
                }
            </div>
            <p className="bold mt-3 mb-1">{t("settings.shared_devices")}</p>
            <div className="d-flex flex-column">
                <div className={`settings-radius`}>
                {loading &&
                    <div className={`p-3 w-100 d-flex flex-column placeholder-glow`} >
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="regular placeholder w-50"></span>
                        </div>
                    </div>
                }
                {sharedDevices && sharedDevices.map((device, index) => (
                    <div key={index} className={`p-3 w-100 d-flex flex-column bg-white ${index < sharedDevices.length-1 ? "border-settings" : ""} cursor-pointer`} onClick={() => clickDevice(device.id)}>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="regular">{device.name}</span>
                            <img className="size_15" src={icons.chevron_right} alt={""} />
                        </div>
                    </div>
                ))}
                </div>
                {sharedDevices && sharedDevices.length === 0 && !loading &&
                    <div className={`p-3 w-100 d-flex flex-column bg-transparent`}>
                        <span className="regular">{t("settings.no_devices")}</span>
                    </div>
                }
            </div>
            <p className={`bold mt-3 mb-1 ${pendingInvites?.length<1 ? "d-none" : ""}`}>{t("settings.device_invitations")}</p>
            <div className="d-flex flex-column">
                <div className={`primary settings-radius`}>
                {pendingInvites && pendingInvites.map((device, index) => (
                    <div key={index} className={`p-3 w-100 d-flex flex-column bg-white ${index < pendingInvites?.length-1 ? "border-settings" : ""}`}>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="regular me-5 text-wrap">{t("settings.invitation_sub", {from: device.sharedstatus.sharedfrom, device: device.name})}</span>
                            <div className="d-flex">
                                <img className="size_15 me-3 cursor-pointer" src={icons.check} alt={""} onClick={() => handleInvite(true, device.id)}/>
                                <img className="size_15 cursor-pointer" src={icons.cross} alt={""} onClick={() => handleInvite(false, device.id)}/>
                            </div>
                        </div>
                    </div>
                ))}
                </div>
            </div>
            <p className="thin mt-3 mb-1">{t("settings.add_share")}</p>         
            <div className="d-flex flex-column">
                <div className="settings-radius">
                    <div className="p-3 d-flex justify-content-between bg-white align-items-center border-settings cursor-pointer" onClick={() => toggleModal("add_device")}>
                        <span className="regular">{t("settings.add_device")}</span>
                        <img className="size_15 grey-blue-icon" src={icons.plus_grey} alt={""} />
                    </div>
                    <div className={`p-3 d-flex justify-content-between bg-white align-items-center ${process.env.REACT_APP_FLAVOR === "alco" ? "border-settings" : ""} cursor-pointer`} onClick={() => toggleModal("share_device")}>
                        <span className="regular">{t("settings.share_device")}</span>
                        <img className="size_15 grey-blue-icon" src={icons.share_grey} alt={""} />
                    </div>
                    
                    {["alco"].includes(process.env.REACT_APP_FLAVOR) &&
                    <div className="p-3 d-flex justify-content-between bg-white align-items-center cursor-pointer" onClick={() => setOuterType("sharing_alarm")}>
                        <span className="regular">{t("settings.share_alarms")}</span>
                        <img className="size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />
                    </div>
                    }
                </div>

            </div>
        </div>
        <AddDeviceModal 
            show={modals[type] ?? false} 
            type={type} 
            onClose={() => toggleModal(type)} 
            onSave={(data) => addDeviceFunc(data)}
            sharableDevices={devicesSharing} 
            updateDevices={() => getDevices()} />
        {/* <AddDevice show={addDevice} onClose={() => setAddDevice(!addDevice)} updateDevices={() => getDevices()} /> */}
        {/* <ShareDevice show={shareDevice} updateDevices={() => getDevices()} devices={devicesSharing} onClose={() => handleShowAddModal("add_device")} /> */}
        </> 
    )

    const deviceSelectedView = () => (
        <>
            <div className="d-flex flex-column mb-5">
                {/* <Button btnClass="btn-left-section" className="align-self-start" icon={icons.back} notext={true} onClick={() => setOpenDevice(null)}/> */}
                <p className="mb-1 bold">{t("settings.edit_device")}</p>
                <div className="d-flex flex-column settings-radius">
                    {validOptions().map((item, index) => (
                        <div onClick={item.function} key={index} className={`p-3 d-flex  ${item.icon ? "cursor-pointer" : ""} justify-content-between bg-white ${index < validOptions().length-1 ? "border-settings" : ""}`}>
                            <span className={`regular ${item.danger ? "text-danger" : ""}`}>{item.title}</span>
                            <div className={`d-flex align-items-center overflow-hidden`}>
                                {item.img ? <img className="size_25" src={item.data} alt=""/> : <p className={`bold text-truncate ms-3`}>{item.data}</p>}
                                {item.icon &&
                                    <img className="ms-3 size_15 grey-blue-icon" src={item.icon} alt={""} />
                                }
                            </div>
                        </div>
                    ))}
                </div>
                {visibleswitch?.documents &&
                <>
                <p className="mb-1 bold mt-3">{t("settings.documents")}</p>
                <div className="d-flex flex-column settings-radius">
                    <div className={`p-3 d-flex justify-content-between bg-white cursor-pointer`} onClick={() => setOuterType("documents")}>
                        <span className={`regular`}>{t("settings.documents")}</span>
                        <div className={`d-flex align-items-center `}>
                            <img className="ms-3 size_15 grey-blue-icon" src={icons.chevron_right} alt={""} />   
                        </div>
                    </div>
                </div>
                </>
                }
                {validInfo().length !== 0 &&
                <>
                <p className="mb-1 bold mt-3">{t("settings.device_info")}</p>
                <div className="d-flex flex-column settings-radius">
                    {validInfo().map((item, index) => (
                        <div key={index} className={`p-3 d-flex justify-content-between bg-white ${index < validInfo().length-1 ? "border-settings" : ""}`}>
                            <span className={`regular ${item.danger ? "text-danger" : ""}`}>{item.title}</span>
                            <div className={`d-flex align-items-center`}>
                                <p className="bold">{item.data}</p>
                            </div>
                        </div>
                    ))}
                </div>
                </>
                }

            </div>
            <AlcolockModal show={showAlcoModal} type={type} data={_external} onClose={() => handleClose()} save={(data) => updateAlcoInfo(data)} />
            <DeviceModal show={showModal} centrals={centrals} deleteData={(data) => deleteData(data)} removeShared={(pending, id, email) => removeShared(pending, id, email)} onSave={(data, reset) => saveData(data, reset)} type={type} data={openDevice} onClose={() => handleClose()}/>
        </>
    )

    const alarmCentralView = () => {
        const allowed = alarmcenter?.allowed
        return(
            <>
            <div className="d-flex flex-column">
                {!allowed &&
                    <>
                    <p className="mb-1 bold">{t("settings.important_information")}</p>
                    <div className="d-flex flex-column settings-radius p-3 d-flex justify-content-between bg-white mb-3">  
                        <p> {t("settings.alarm_center_not_allowed")}</p>
                    </div>
                    </>
                }
                <p className="mb-1 bold">{t("settings.edit_settings")}</p>
                <div className="d-flex flex-column settings-radius">
                    {validAlarmCentral().map((item, index) => (
                    <div key={index} onClick={!allowed ? null : item.function} className={`p-3 d-flex justify-content-between bg-white ${!allowed ? "grey" : "cursor-pointer "} ${index < validAlarmCentral().length-1 ? "border-settings" : ""}`}>
                        <span className={`regular ${item.danger ? "text-danger" : ""}`}>{item.title}</span>
                        <div className={`d-flex align-items-center `}>
                            <p className="bold">{item.data}</p>
                            <img className={`ms-3 size_15 ${!allowed ? "grey-icon" : "grey-blue-icon"}`} src={icons.dots_vertical} alt={""} />  
                        </div>
                    </div> 
                    ))}
                </div>
                {alarmcenter?.centerid !== null && allowed &&
                <>
                    <p className="mb-1 bold mt-3">{t("settings.downloads")}</p>
                    <div className="d-flex flex-column settings-radius">
                        <div className={`p-3 d-flex justify-content-between bg-white border-settings ${!allowed ? "grey" : "cursor-pointer "}`} onClick={() => !allowed ? null : downloadPDF(alarmcenter?.centercontracturl)}>
                            <span className={`regular`}>{t("settings.alarm_central_contract")}</span>
                            <div className={`d-flex align-items-center`}>
                                <img className={`ms-3 size_15 ${!allowed ? "grey-icon" : "grey-blue-icon"}`} src={icons.download} alt={""} />  
                            </div>
                        </div>
                        <div className={`p-3 d-flex justify-content-between bg-white ${!allowed ? "grey" : "cursor-pointer "}`} onClick={() => !allowed ? null : downloadCertificate()}>
                            <span className={`regular`}>{t("settings.installation_certificate")}</span>
                            <div className={`d-flex align-items-center `}>
                                <img className={`ms-3 size_15 ${!allowed ? "grey-icon" : "grey-blue-icon"}`} src={icons.download} alt={""} />  
                            </div>
                        </div>    
                    </div>  
                </>
                }
            </div>
            <AlarmCentralModal show={showAlarmModal} postTest={() => getTestInfo(true)} sendTestAlarm={() => sendTestAlarm()} centrals={centrals} testInfo={testInfo} deleteData={(data) => deleteData(data)} removeShared={(pending, id, email) => removeShared(pending, id, email)} onSave={(data, reset) => saveDataAlarm(data, reset)} type={alarmType} data={openDevice} onClose={() => setShowAlarmModal(!showAlarmModal)}/>
            </>
        )
    }


        const exportDataView = () => (
        <>
        <div className="d-flex flex-column mb-5">
            {/* <h3 className="my-2">{t("settings.export_data")}</h3> */}
            <p className="mb-1 bold">{t("settings.new_export")}</p>
            <div className="d-flex flex-column settings-radius"> 
                <div className={`p-3 d-flex justify-content-between bg-white cursor-pointer`} onClick={() => openExportModal("generate")}>
                    <span className={`regular`}>{t("settings.create_export")}</span>
                    <div className={`d-flex align-items-center`}>
                        {/* <p className="bold">{item.data}</p> */}
                        <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />  
                    </div>
                </div> 
            </div>
            <p className="mb-1 bold mt-3">{t("settings.previous_exports")}</p>
                {exportedList?.length == 0 &&
                    <h3 className="bold dark-grey text-center mt-3">{t("settings.no_data")}</h3>
                }
                <div className="d-flex flex-column settings-radius">
                    {exportedList?.map((item, index) => (
                        <div key={index} className={`p-3 d-flex justify-content-between bg-white cursor-pointer ${index < exportedList?.length-1 ? "border-settings" : ""}`} onClick={() => item?.ready ? openExportModal("download", item) : toast.error(t("settings.processing"))}>
                            <div className="d-flex flex-column">
                                <p className={"body"}>{t(`settings.${item.type}`)}</p>
                                {/* <p>{item?.expired ? t("settings.expired") : item?.ready ? t("settings.ready") : t("settings.processing")}</p> */}
                                <p className={`dark-grey`}>{`${fixDate(item?.period?.from, true)} - ${fixDate(item?.period?.to, true)}`}</p>
                            </div>
                            <div className={`d-flex align-items-center`}>
                                <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />
                            </div>
                        </div>
                    ))}
                </div>      
        </div>
        <ExportDataModal show={showExportModal} info={openDevice?.exportdata/*exportInfo*/} device={openDevice} type={exportType} download={(url) => downloadData(url)} onSave={(data, reset) => saveDataExport(data, reset)} onClose={() => setShowExportModal(!showExportModal)}/>
        </>
    )

    const stolenModeView = () => {
        const items1 = [
            {
                name: "additional",
                icon: icons.dots_vertical,
                function: () => handleOpenStolenMode("additional")
            },
        ]
        const items2 = [

            {
                name: "link",
                icon: icons.dots_vertical,
                function: () => handleOpenStolenMode("link")
            }
        ]
        return(
        <>
        <div className="d-flex flex-column">
            {/* <h3 className="my-2">{t("settings.stolen_mode")}</h3> */}
            <p className="mb-1 bold">{t("settings.important_information")}</p>
            <div className="bg-white rounded24 p-3 mb-3">
                <p>{t("settings.stolen_mode_desc")}</p>
            </div>
            <p className="mb-1 bold">{t("settings.configuration")}</p>
            <div className="d-flex flex-column primary settings-radius mb-3">
                <div className={`py-2 px-3 d-flex justify-content-between align-items-center bg-white border-settings`}>
                    <h4 className="regular">{t("settings.stolen_mode")}</h4>
                    <div className="form-check form-switch">
                        <input className="form-check-input" onChange={() => handleOpenStolenMode(stolenModeInfo?.active ? "deactivate" : "activate")} type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={stolenModeInfo?.active ?? false} />
                    </div>
                </div>
                {items1.map((item, index) => (
                        <div 
                        key={index} 
                        className={`p-3 d-flex justify-content-between bg-white ${index < items1.length-1 ? "border-settings" : ""} ${item.icon ? "cursor-pointer" : ""}`} onClick={item.function}>
                            <h4 className="regular align-self-center">{t(`settings.${item.name}`)}</h4>
                            <div className={`d-flex flex-${item.extra ? "column" : "row"} align-items-center`}> 
                                <p className="m-0 p-0">{item.data}</p>
                                {item.extra && <p className="m-0 p-0 dark_grey">{`(${item.extra})`}</p>}
                                {item.icon &&
                                    <img className="ms-3 size_15 grey-blue-icon" src={item.icon} alt={""} />
                                }
                            </div>
                        </div>
                    ))}
            </div>
            <div className={`d-flex flex-column settings-radius primary ${!stolenModeInfo?.active ? "d-none" : ""}`}>
                {items2.map((item, index) => (
                    <div 
                    key={index} 
                    className={`p-3 d-flex justify-content-between bg-white ${index < items2.length-1 ? "border-settings" : ""} ${item.icon ? "cursor-pointer" : ""}`} onClick={item.function}>
                        <h4 className="regular align-self-center">{t(`settings.${item.name}`)}</h4>
                        <div className={`d-flex flex-${item.extra ? "column" : "row"} align-items-center`}> 
                            <p className="m-0 p-0">{item.data}</p>
                            {item.extra && <p className="m-0 p-0 dark_grey">{`(${item.extra})`}</p>}
                            {item.icon &&
                                <img className="ms-3 size_15 grey-blue-icon" src={item.icon} alt={""} />
                            }
                        </div>
                    </div>
                ))}
            </div>  
        </div>
        <StolenModeModal show={showStolenModeModal} info={stolenModeInfo} type={stolenModeType} device={openDevice} download={(url) => downloadData(url)} onSave={(data, reset) => saveDataStolenMode(data, reset)} deleteImg={() => deleteStolenModeImg()} onClose={() => setShowStolenModeModal(!showStolenModeModal)}/>
        </>
        )
    }

    const documentsView = () => {
        const docu = openDevice?.documents
        return(
        <div className="d-flex flex-column">
            <p className="mb-1 bold">{docu?.productname}</p>
            <div className="d-flex flex-column settings-radius">
                {docu?.list?.map((item, index) => (
                    <div key={index} className={`p-3 d-flex justify-content-between bg-white cursor-pointer ${index < docu?.list?.length-1 ? "border-settings" : ""}`} onClick={() => downloadPDF(item.pdfurl)}>
                        <span className={`regular`}>{item.titel}</span>
                        <div className={`d-flex align-items-center`}>
                            <img className="ms-3 size_15 grey-blue-icon" src={icons.download} alt={""} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
        )
    }

    const sharingAlarmView = () => {

        return(
            <>
            <div className="d-flex flex-column">
                <p className="mb-1 bold">{t("settings.devices")}</p>
                <div className="d-flex flex-column settings-radius">
                    {sharingDevices.map((item, index) => (
                        <div key={index} className={`p-3 d-flex justify-content-between bg-white ${index < sharingDevices.length-1 ? "border-settings" : ""} cursor-pointer`} onClick={() => toggleSharingModal("alarm_item", item)}>
                            <span className={`regular`}>{item.devicename}</span>
                            <div className={`d-flex align-items-center`}>
                                <div className="d-flex flex-column align-items-center">
                                    <p className="text-end">{item?.shared?.shared ? `${t("settings.shared")} (${item?.shared?.amount})` : t("settings.not_shared")}</p>
                                </div>
                                <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />
                            </div>
                        </div>
                    ))}

                </div>
                {sharingDevices.length === 0 &&
                    <p className="grey-blue pb-3">{t("settings.no_devices")}</p>
                }
                <p className="mb-1 bold mt-3">{t("settings.share_multiple")}</p>
                <div className="d-flex flex-column settings-radius">
                    <div className={`p-3 d-flex justify-content-between bg-white`}>
                        <span className={`regular`}>{t("settings.share_multiple")}</span>
                        <div className={`d-flex align-items-center cursor-pointer`} onClick={() => toggleSharingModal("share_multiple", sharingDevices)}>
                            <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />   
                        </div>
                    </div>
                </div>
                <p className="mb-1 bold mt-3">{t("settings.remove_email")}</p>
                <div className="d-flex flex-column settings-radius">
                    <div className={`p-3 d-flex justify-content-between bg-white`}>
                        <span className={`regular`}>{t("settings.remove_emailadress")}</span>
                        <div className={`d-flex align-items-center cursor-pointer`} onClick={() => toggleSharingModal("remove_email")}>
                            <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />   
                        </div>
                    </div>
                </div>
            </div>
            <SharingModal show={showSharingModal} type={type} info={sharingAccount} onClose={() => handleClose()} onSave={(data) => updateSharing(data)}/>
            </>
        )
    }

    const sharingView = () => {
        const statusDev = devicesSharing?.find(dev => dev.id === openDevice?.id)

        const current = statusDev?.shared_permissions?.sharedto_count
        const max = statusDev?.shared_permissions?.sharedlimit
        const msg = statusDev?.shared_permissions?.info_message
        return(
            <>
            <div className="d-flex flex-column">
                <p className="mb-1 bold">{`${t("settings.accounts_shared_with")} (${current}/${max})`}</p>
                <div className="d-flex flex-column settings-radius">
                    {sharedstatus?.sharedwith?.map((item, index) => (
                        <div key={index} onClick={() => toggleSharingModal("status", item)} className={`p-3 d-flex cursor-pointer justify-content-between bg-white ${index < sharedstatus?.sharedwith?.length-1 ? "border-settings" : ""}`}>
                            <span className={`regular`}>{item.email}</span>
                            <div className={`d-flex align-items-center`}>
                                <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />
                            </div>
                        </div>
                    ))}

                </div>
                {sharedstatus?.sharedwith?.length === 0 &&
                    <p className="grey-blue pb-3">{t("settings.no_shared_accounts")}</p>
                }
                <p className="mb-1 bold mt-3">{t("settings.share_device")}</p>
                <div className="d-flex flex-column settings-radius">
                    <div className={`p-3 d-flex justify-content-between bg-white cursor-pointer`}  onClick={() => current >= max ? toast(msg ?? t("toast.error")) : toggleSharingModal("share_device")}>
                        <span className={`regular`}>{t("settings.share_device")}</span>
                        <div className={`d-flex align-items-center`}>
                                {current >= max 
                                    ? <img className="cursor-pointer primary-icon" src={icons.info_icon} alt={""} />
                                    : <img className="ms-3 size_15 grey-blue-icon" src={icons.dots_vertical} alt={""} />
                                }
                        </div>
                    </div>
                </div>
            </div>
            <SharingModal show={showSharingModal} type={type} info={sharingAccount} onClose={() => handleClose()} onSave={(data) => updateSharing(data)}/>
            </>
        )
    }


    return(
        <>
        {!openDevice && !alarmCentralShow && !exportDataShow && !stolenModeShow && !documentsShow && !sharingShow && !sharingAlarmShow && noDeviceSelectedView()}
        {openDevice && !alarmCentralShow && !exportDataShow && !stolenModeShow && !documentsShow && !sharingShow && !sharingAlarmShow && deviceSelectedView()}
        {documentsShow && documentsView()}
        {alarmCentralShow && alarmCentralView()}
        {exportDataShow && exportDataView()}
        {stolenModeShow && stolenModeView()}
        {sharingShow && sharingView()}
        {sharingAlarmShow && sharingAlarmView()}
        </>
    )
}

export default Devices;